// removed by extract-text-webpack-plugin
module.exports = {"root":"cms__App__root","sidebar":"cms__App__sidebar"};


//////////////////
// WEBPACK FOOTER
// ./containers/App.css
// module id = 562
// module chunks = 0